import React, { Fragment, Suspense, lazy, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { logout } from '../../actions/auth';
import {
    openNavDrawer,
    closeNavDrawer,
    changeHats,
    // openUserDrawer,
    // closeUserDrawer,
    openLoginDialog,
    closeLoginDialog,
} from '../../actions/app';
import { ProfileAvatar } from '../../common/components';

import { getCurrentArtist, setCurrentArtist } from '../../actions/artist';
import { getCurrentHost } from '../../actions/host';
import { getCurrentAttendee } from '../../actions/attendee';
import {
    getMyEventsOfferedToHost,
    getMyArtistEventsOffers,
    getEventsNearMeToHost,
    getDiffArtistEventsOffers,
} from '../../actions/event';

import {
    Avatar,
    Button,
    AppBar,
    Container,
    Box,
    Toolbar,
    MenuItem,
    Tooltip,
    IconButton,
    Menu,
    Typography,
    ListItemIcon,
    Autocomplete,
    TextField,
    Dialog,
    DialogContent,
} from '@mui/material';

import LoginIcon from '@mui/icons-material/Login';
import MenuIcon from '@mui/icons-material/Menu';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import AutoAwesomeTwoToneIcon from '@mui/icons-material/AutoAwesomeTwoTone';
import DateRangeTwoToneIcon from '@mui/icons-material/DateRangeTwoTone';
import AccountBoxTwoToneIcon from '@mui/icons-material/AccountBoxTwoTone';
import DashboardTwoToneIcon from '@mui/icons-material/DashboardTwoTone';
import LogoutIcon from '@mui/icons-material/Logout';
import SpeakerNotesOffTwoToneIcon from '@mui/icons-material/SpeakerNotesOffTwoTone';
import MapTwoToneIcon from '@mui/icons-material/MapTwoTone';

import Alert from './Alert';
import Spinner from './Spinner';
import { resendVerificationEmail } from '../../actions/auth';
import ArtistTop from '../artists/ArtistTop';
import EditHostSettings from '../hosts/EditHostSettings';
import NotificationsBell from '../notifications/NotificationsBell';

const HostDataGridMap = lazy(() => import('../hosts/HostDataGridMap'));
const AttendeeDataGridMap = lazy(
    () => import('../attendees/AttendeeDataGridMap')
);
const Login = lazy(() => import('../auth/Login'));
const Register = lazy(() => import('../auth/Register'));
const ForgotPassword = lazy(() => import('../auth/ForgotPassword'));

const Navbar = ({
    auth: { isAuthenticated, loading, user },
    logout,
    openNavDrawer,
    closeNavDrawer,
    changeHats,
    openLoginDialog,
    closeLoginDialog,
    // openUserDrawer,
    // closeUserDrawer,
    getCurrentArtist,
    setCurrentArtist,
    getCurrentHost,
    getCurrentAttendee,
    getMyEventsOfferedToHost,
    getEventsNearMeToHost,
    getMyArtistEventsOffers,
    getDiffArtistEventsOffers,
    app: {
        navDrawer,
        userDrawer,
        profileHat,
        pageURL,
        loginDialogOpen: globalLoginOpen,
        loginDialogContext: dialogCtx,
    },
    artist,
    host,
    events: { myHostEvents, myArtistEvents },
    resendVerificationEmail,
}) => {
    const [anchorElUser, setAnchorElUser] = React.useState(null);

    const [avatar, setAvatar] = useState();
    const location = useLocation();
    const currentPath = location?.pathname || '';
    const onEditHosts =
        currentPath === '/edit-hosts' || pageURL === '/edit-hosts';
    const onEditAttendees =
        currentPath === '/edit-attendees' || pageURL === '/edit-attendees';
    const isEventPage =
        location && location.pathname
            ? location.pathname.indexOf('/events/') === 0
            : false;
    const eventIdFromPath = (() => {
        try {
            const m =
                location && location.pathname
                    ? location.pathname.match(/^\/events\/([^/?#]+)/)
                    : null;
            return m ? m[1] : null;
        } catch (_) {
            return null;
        }
    })();
    const tokenFromQuery = (() => {
        try {
            return new URLSearchParams(location.search).get('token');
        } catch (_) {
            return null;
        }
    })();

    useEffect(() => {
        if (user && user.avatar) {
            setAvatar(user.avatar);
        }
    }, [user]);

    useEffect(() => {
        if (
            isAuthenticated &&
            user &&
            user.role &&
            Array.isArray(user.role) &&
            user.role.indexOf('ATTENDEE') != -1
        ) {
            getCurrentAttendee();
        }
    }, [getCurrentAttendee, user]);
    useEffect(() => {
        if (
            isAuthenticated &&
            user &&
            user.role &&
            Array.isArray(user.role) &&
            user.role.indexOf('ARTIST') != -1
        ) {
            getCurrentArtist();
            getMyArtistEventsOffers();
        }
    }, [getCurrentArtist, user]);
    useEffect(() => {
        if (
            isAuthenticated &&
            user &&
            user.role &&
            Array.isArray(user.role) &&
            user.role.indexOf('HOST') != -1
        ) {
            getCurrentHost();
            getMyEventsOfferedToHost();
            getEventsNearMeToHost();
        }
    }, [getCurrentHost, user]);

    const isLoginOpen = !!globalLoginOpen;
    const isEmailVerified = React.useMemo(() => {
        if (!user || !user.verifiedEmail) return false;
        try {
            const t = new Date(user.verifiedEmail).getTime();
            return !Number.isNaN(t);
        } catch {
            return false;
        }
    }, [user && user.verifiedEmail]);
    const dialogMode = (dialogCtx && dialogCtx.mode) || 'login';
    const context = dialogCtx || {};
    const contextEventId = context.eventId || eventIdFromPath;
    const contextToken = context.token || tokenFromQuery;

    useEffect(() => {
        if (isLoginOpen && isAuthenticated) {
            // Avoid forcing a full reload on event pages; let state updates refresh views
            closeLoginDialog();
        }
    }, [isAuthenticated, isLoginOpen, closeLoginDialog]);

    // Close the login dialog if user navigates to auth-related standalone pages
    useEffect(() => {
        const closeOnPaths = [
            '/register',
            '/forgot-password',
            '/reset-password',
            '/verify-email',
        ];
        if (
            location &&
            location.pathname &&
            closeOnPaths.some((p) => location.pathname.indexOf(p) === 0)
        ) {
            closeLoginDialog();
        }
    }, [location.pathname, closeLoginDialog]);

    const handleOpenNavMenu = (event) => {
        openNavDrawer();
    };
    const handleOpenUserMenu = (event) => {
        //openUserDrawer();
        setAnchorElUser(event.currentTarget);
    };
    const handleOpenLoginDialog = (e) => {
        if (e && e.preventDefault) e.preventDefault();
        openLoginDialog({
            source: isEventPage ? 'event_login' : 'navbar_login',
            mode: 'login',
            eventId: eventIdFromPath,
            token: tokenFromQuery,
        });
    };

    const handleCloseNavMenu = () => {
        closeNavDrawer();
    };

    const handleCloseUserMenu = () => {
        //closeUserDrawer();
        setAnchorElUser(null);
    };

    const handleResendVerificationClick = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        if (e && e.stopPropagation) e.stopPropagation();
        if (resendVerificationEmail) {
            try {
                await resendVerificationEmail();
            } catch (_) {}
        }
    };

    const guestLinks = [
        isEventPage ? (
            <a href="#!" onClick={handleOpenLoginDialog} key="guestLoginLink">
                <ListItemIcon>
                    <LoginIcon></LoginIcon>
                </ListItemIcon>
                Login
            </a>
        ) : (
            <Link
                to={{ pathname: '/login', search: location.search }}
                key="guestLoginLink"
            >
                <ListItemIcon>
                    <LoginIcon></LoginIcon>
                </ListItemIcon>
                Login
            </Link>
        ),
    ];

    const dashboardLink = [
        <Link to="/dashboard" key="dashboardLink">
            <ListItemIcon>
                <DashboardTwoToneIcon></DashboardTwoToneIcon>
            </ListItemIcon>
            My Dashboard
        </Link>,
    ];

    const logoutLink = [
        <a onClick={logout} href="#!" key="logoutLink">
            <ListItemIcon>
                <LogoutIcon></LogoutIcon>
            </ListItemIcon>
            Logout
        </a>,
    ];

    const signUpToHostLinks = [
        <Link to="/edit-host-profile" key="signupHostProfile">
            <ListItemIcon>
                <AutoAwesomeTwoToneIcon></AutoAwesomeTwoToneIcon>
            </ListItemIcon>
            Sign Up to Host
        </Link>,
    ];

    const editAttendeeAccountLinks = [
        <Link to="/edit-attendee-profile" key="editAttendeeProfile">
            <ListItemIcon>
                <EditTwoToneIcon></EditTwoToneIcon>
            </ListItemIcon>
            Edit My Account Info
        </Link>,
    ];

    const hostLinks = [
        <EditHostSettings />,
        <Link to="/edit-host-profile" key="editHostProfile">
            <ListItemIcon>
                <EditTwoToneIcon></EditTwoToneIcon>
            </ListItemIcon>
            Edit My Host Profile
        </Link>,
    ];

    const artistLinks = [
        artist.me && artist.me.slug ? (
            <Link to={'/artists/' + artist.me.slug} key="artistProfile">
                <ListItemIcon>
                    <AccountBoxTwoToneIcon></AccountBoxTwoToneIcon>
                </ListItemIcon>
                My Artist Profile
            </Link>
        ) : (
            ''
        ),
        <Link to="/edit-artist-profile" key="editArtistProfile">
            <ListItemIcon>
                <EditTwoToneIcon></EditTwoToneIcon>
            </ListItemIcon>
            Edit My Artist Profile
        </Link>,
        // (artist.me &&
        //     artist.me._id &&
        //     artist.me.active &&
        //     artist.me.bookingWhen.length > 0) ||
        // (isAuthenticated &&
        //     Array.isArray(user.role) &&
        //     user.role.indexOf('ADMIN') != -1 &&
        //     artist.me &&
        //     artist.me._id &&
        //     artist.me.bookingWhen.length > 0) ? ( //if ADMIN
        //     <Link to="/edit-artist-booking">
        //         <ListItemIcon>
        //             <DateRangeTwoToneIcon></DateRangeTwoToneIcon>
        //         </ListItemIcon>
        //         Edit My Booking Info
        //     </Link>
        // ) : (artist.me && artist.me._id && artist.me.active) ||
        //   (isAuthenticated &&
        //       Array.isArray(user.role) &&
        //       user.role.indexOf('ADMIN') != -1) ? (
        //     <Link to="/edit-artist-booking">
        //         <ListItemIcon>
        //             <DateRangeTwoToneIcon></DateRangeTwoToneIcon>
        //         </ListItemIcon>
        //         Start Booking Shows
        //     </Link>
        // ) : (
        //     ''
        // ),
    ];

    const adminLinks = [];

    // const loggedInLinks = [
    //     <Link to="/dashboard">
    //         <ListItemIcon>
    //             <DashboardTwoToneIcon></DashboardTwoToneIcon>
    //         </ListItemIcon>
    //         My Dashboard
    //     </Link>,
    //     artist && artist.me && artist.me.slug ? (
    //         <Link to={'/artists/' + artist.me.slug}>
    //             <ListItemIcon>
    //                 <AccountBoxTwoToneIcon></AccountBoxTwoToneIcon>
    //             </ListItemIcon>
    //             My Artist Profile
    //         </Link>
    //     ) : (
    //         ''
    //     ),
    //     artist.me && artist.me._id ? (
    //         <Link to="/edit-artist-profile">
    //             <ListItemIcon>
    //                 <EditTwoToneIcon></EditTwoToneIcon>
    //             </ListItemIcon>
    //             Edit My Artist Profile
    //         </Link>
    //     ) : (
    //         <Link to="/edit-artist-profile">
    //             <ListItemIcon>
    //                 <AutoAwesomeTwoToneIcon></AutoAwesomeTwoToneIcon>
    //             </ListItemIcon>
    //             Create My Artist Profile
    //         </Link>
    //     ),
    //     (artist.me &&
    //         artist.me._id &&
    //         artist.me.active &&
    //         artist.me.bookingWhen.length > 0) ||
    //     (isAuthenticated &&
    //         Array.isArray(user.role) &&
    //         user.role.indexOf('ADMIN') != -1 &&
    //         artist.me &&
    //         artist.me._id &&
    //         artist.me.bookingWhen.length > 0) ? ( //if ADMIN
    //         <Link to="/edit-artist-booking">
    //             <ListItemIcon>
    //                 <DateRangeTwoToneIcon></DateRangeTwoToneIcon>
    //             </ListItemIcon>
    //             Edit My Booking Info
    //         </Link>
    //     ) : (artist.me && artist.me._id && artist.me.active) ||
    //       (isAuthenticated &&
    //           Array.isArray(user.role) &&
    //           user.role.indexOf('ADMIN') != -1) ? (
    //         <Link to="/edit-artist-booking">
    //             <ListItemIcon>
    //                 <DateRangeTwoToneIcon></DateRangeTwoToneIcon>
    //             </ListItemIcon>
    //             Start booking shows
    //         </Link>
    //     ) : (
    //         ''
    //     ),
    //     isAuthenticated &&
    //     Array.isArray(user.role) &&
    //     user.role.indexOf('ADMIN') != -1 ? ( //if ADMIN
    //         <Link to="/edit-host-profile">
    //             <ListItemIcon>
    //                 <EditTwoToneIcon></EditTwoToneIcon>
    //             </ListItemIcon>
    //             Edit My Host Profile
    //         </Link>
    //     ) : (
    //         ''
    //     ),
    //     <a onClick={logout} href="#!">
    //         <ListItemIcon>
    //             <LogoutIcon></LogoutIcon>
    //         </ListItemIcon>
    //         Logout
    //     </a>,
    // ];
    // const loggedOutLink = [
    //     <Link to="/login">
    //         <ListItemIcon>
    //             <LoginIcon></LoginIcon>
    //         </ListItemIcon>
    //         Login
    //     </Link>,
    // ];

    //let userLinks = isAuthenticated ? loggedInLinks : loggedOutLink;

    const myNavLinks = () => {
        let combinedLinks = [guestLinks];
        if (isAuthenticated) {
            combinedLinks = [dashboardLink];
        }
        if (
            isAuthenticated &&
            Array.isArray(user.role) &&
            user.role.indexOf('ATTENDEE') != -1 &&
            user.role.indexOf('HOST') === -1
        ) {
            combinedLinks = combinedLinks.concat(signUpToHostLinks);
        }
        if (
            isAuthenticated &&
            Array.isArray(user.role) &&
            user.role.indexOf('ATTENDEE') != -1
        ) {
            combinedLinks = combinedLinks.concat(editAttendeeAccountLinks);
        }
        if (
            isAuthenticated &&
            Array.isArray(user.role) &&
            user.role.indexOf('HOST') != -1
        ) {
            combinedLinks = combinedLinks.concat(hostLinks);
        }

        if (
            isAuthenticated &&
            Array.isArray(user.role) &&
            user.role.indexOf('ARTIST') != -1
        ) {
            combinedLinks = combinedLinks.concat(artistLinks);
        }
        if (
            isAuthenticated &&
            Array.isArray(user.role) &&
            user.role.indexOf('ADMIN') != -1
        ) {
            combinedLinks = combinedLinks.concat(adminLinks);
        }

        if (isAuthenticated) {
            combinedLinks = combinedLinks.concat(logoutLink);
        }
        return combinedLinks;
    };

    return (
        <>
            <AppBar
                position="sticky"
                sx={{
                    borderBottom: '1px solid var(--primary-color)',
                    backgroundImage: 'none',
                    backgroundColor: 'var(--secondary-dark-color)',
                }}
            >
                <Container maxWidth={false}>
                    <Toolbar disableGutters>
                        <Box
                            sx={{
                                flexGrow: 1,
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={
                                    !navDrawer
                                        ? handleOpenNavMenu
                                        : handleCloseNavMenu
                                }
                                color="inherit"
                            >
                                <MenuIcon />
                            </IconButton>
                        </Box>
                        {onEditHosts && (
                            <Suspense
                                fallback={
                                    <Box className="mapButton">
                                        <IconButton
                                            size="large"
                                            color="inherit"
                                            aria-label="Open hosts map"
                                        >
                                            <MapTwoToneIcon />
                                        </IconButton>
                                    </Box>
                                }
                            >
                                <HostDataGridMap />
                            </Suspense>
                        )}
                        {onEditAttendees && (
                            <Suspense
                                fallback={
                                    <Box className="mapButton">
                                        <IconButton
                                            size="large"
                                            color="inherit"
                                            aria-label="Open attendees map"
                                        >
                                            <MapTwoToneIcon />
                                        </IconButton>
                                    </Box>
                                }
                            >
                                <AttendeeDataGridMap />
                            </Suspense>
                        )}
                        {(currentPath === '/artists' ||
                            pageURL === '/artists') && (
                            <Box className="mapButton">
                                <IconButton
                                    size="large"
                                    aria-label="Scroll to artist map"
                                    onClick={() => {
                                        const mapSection =
                                            document.getElementById(
                                                'artists-map'
                                            );
                                        if (mapSection) {
                                            mapSection.scrollIntoView({
                                                behavior: 'smooth',
                                                block: 'start',
                                            });
                                        }
                                    }}
                                    color="inherit"
                                >
                                    <MapTwoToneIcon />
                                </IconButton>
                            </Box>
                        )}
                        {isAuthenticated &&
                            Array.isArray(user.role) &&
                            user.role.indexOf('ADMIN') != -1 &&
                            pageURL === '/dashboard' &&
                            artist &&
                            artist.artists &&
                            artist.artists.length > 0 && (
                                <Box>
                                    <Autocomplete
                                        value={
                                            artist.artists.find(
                                                (a) =>
                                                    a.email ===
                                                    (artist.me
                                                        ? artist.me.email
                                                        : '')
                                            ) || null
                                        }
                                        onChange={(event, artistOption) => {
                                            if (artistOption) {
                                                getDiffArtistEventsOffers(
                                                    artistOption.email
                                                );
                                                setCurrentArtist(artistOption);
                                            }
                                        }}
                                        options={artist.artists}
                                        getOptionLabel={(artistOption) =>
                                            artistOption.stageName
                                        }
                                        renderInput={(params) => (
                                            <TextField {...params} />
                                        )}
                                        sx={{
                                            width: '300px',
                                        }}
                                    />
                                </Box>
                            )}
                        <Typography
                            variant="h6"
                            noWrap
                            component="div"
                            sx={{
                                flexGrow: 1,
                                display: { xs: 'flex', md: 'flex' },
                            }}
                        >
                            {/* Hidden on mobile — AlertToast shows the same
                                alerts at the bottom of the viewport there. */}
                            <Box
                                sx={{
                                    display: { xs: 'none', md: 'flex' },
                                    width: '100%',
                                }}
                            >
                                <Alert />
                            </Box>
                        </Typography>

                        <Box sx={{ flexGrow: 0, display: 'flex', alignItems: 'center' }}>
                            <NotificationsBell />
                            <Tooltip
                                title={
                                    !isAuthenticated
                                        ? 'Account Menu'
                                        : isEmailVerified
                                          ? 'Account Menu'
                                          : 'Please verify your email address.'
                                }
                            >
                                <IconButton
                                    onClick={handleOpenUserMenu}
                                    sx={{ p: 0 }}
                                    size="large"
                                >
                                    <Box
                                        sx={{
                                            position: 'relative',
                                            display: 'inline-flex',
                                        }}
                                    >
                                        {user &&
                                        user.name &&
                                        user.avatar !== null ? (
                                            <Avatar
                                                alt={`${
                                                    profileHat === 'HOST' &&
                                                    host &&
                                                    host.me
                                                        ? host.me.firstName +
                                                          ' ' +
                                                          host.me.lastName
                                                        : profileHat ===
                                                                'ARTIST' &&
                                                            artist &&
                                                            artist.me
                                                          ? artist.me.stageName
                                                          : user.name
                                                }`}
                                                src={`${
                                                    profileHat === 'HOST' &&
                                                    host &&
                                                    host.me
                                                        ? host.me.profileImg
                                                        : profileHat ===
                                                                'ARTIST' &&
                                                            artist &&
                                                            artist.me
                                                          ? artist.me.squareImg
                                                          : user.avatar
                                                }`}
                                            />
                                        ) : (
                                            <Avatar />
                                        )}
                                        {isAuthenticated &&
                                            !isEmailVerified && (
                                                <Box
                                                    sx={{
                                                        backgroundColor:
                                                            'rgba(0,0,0,0.5)',
                                                        // padding: '8px',
                                                        borderRadius: '50%',
                                                        position: 'absolute',
                                                        top: '50%',
                                                        left: '50%',
                                                        transform:
                                                            'translate(-50%, -50%)',
                                                    }}
                                                >
                                                    <SpeakerNotesOffTwoToneIcon
                                                        sx={{
                                                            // position:
                                                            //     'absolute',
                                                            // top: '50%',
                                                            // left: '50%',
                                                            // transform:
                                                            //     'translate(-50%, -50%)',
                                                            fontSize: '2.9rem',
                                                            padding: '8px',
                                                            color: 'var(--link-color)',
                                                            pointerEvents:
                                                                'none',
                                                        }}
                                                    />
                                                </Box>
                                            )}
                                    </Box>
                                </IconButton>
                            </Tooltip>
                            <Menu
                                sx={{ mt: '45px' }}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                                onClick={handleCloseUserMenu}
                                className="porchlightBG"
                            >
                                {user && user.name && user.avatar !== null && (
                                    <Box
                                        key="nameEmail"
                                        className="nameEmailBox"
                                        sx={{
                                            width: '100%',
                                            padding: !isEmailVerified
                                                ? '20px'
                                                : '20px 20px 0px 20px',
                                            marginTop: !isEmailVerified
                                                ? '-8px'
                                                : '0px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            flexDirection: 'column',
                                            border: !isEmailVerified
                                                ? '3px dashed var(--primary-color)'
                                                : 'none',
                                            backgroundImage: !isEmailVerified
                                                ? 'repeating-linear-gradient(45deg,     rgba(255,255,255,0.03) 5px,    rgba(255,255,255,.03) 15px,    transparent 15px,    transparent 30px)'
                                                : 'none',
                                            backgroundColor: !isEmailVerified
                                                ? 'rgba(0,0,0,0.35)'
                                                : 'transparent',
                                        }}
                                    >
                                        <Typography
                                            sx={{ textAlign: 'center' }}
                                        >
                                            {profileHat === 'HOST' &&
                                            host &&
                                            host.me
                                                ? host.me.firstName +
                                                  ' ' +
                                                  host.me.lastName
                                                : profileHat === 'ARTIST' &&
                                                    artist &&
                                                    artist.me
                                                  ? artist.me.stageName
                                                  : user && user.name
                                                    ? user.name
                                                    : ''}
                                        </Typography>
                                        <Typography
                                            sx={{
                                                opacity:
                                                    isAuthenticated &&
                                                    !isEmailVerified
                                                        ? 1
                                                        : 0.2,
                                                color:
                                                    isAuthenticated &&
                                                    !isEmailVerified
                                                        ? 'var(--light-color)'
                                                        : 'var(--primary-color)',
                                                fontSize: '.7em',
                                            }}
                                        >
                                            ({user && user.email})
                                        </Typography>
                                        {isAuthenticated &&
                                            !isEmailVerified && (
                                                <Typography
                                                    variant="caption"
                                                    sx={{
                                                        mt: 0.5,
                                                        textAlign: 'center',
                                                        maxWidth: '260px',
                                                        color: 'var(--primary-color)',
                                                    }}
                                                >
                                                    Your email isn’t verified
                                                    yet.
                                                    <br />
                                                    <a
                                                        href="#!"
                                                        onClick={
                                                            handleResendVerificationClick
                                                        }
                                                        style={{
                                                            color: 'var(--link-color)',
                                                            textDecoration:
                                                                'underline',
                                                        }}
                                                    >
                                                        Resend verification
                                                        email
                                                    </a>
                                                </Typography>
                                            )}
                                    </Box>
                                )}
                                {myNavLinks().map((userLink, index) => (
                                    <MenuItem
                                        key={userLink + index}
                                        onClick={handleCloseNavMenu}
                                        sx={{ padding: 0 }}
                                        className="drawerListItems"
                                    >
                                        {userLink}
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
            <Dialog
                open={isLoginOpen}
                onClose={() => {
                    closeLoginDialog();
                }}
                scroll="body"
                fullWidth
                maxWidth="sm"
                className="porchlightBG"
                // disableScrollLock
                // keepMounted
                disableEnforceFocus={false}
                disableAutoFocus={false}
                disableRestoreFocus={false}
            >
                <DialogContent>
                    <Suspense fallback={<Spinner />}>
                        {dialogMode === 'register' ? (
                            <Register
                                bookingDialog
                                inviteEventId={contextEventId}
                                inviteToken={contextToken}
                                inviteNonce={context.nonce}
                                inviteReturnTo={context.returnTo}
                                inviteRsvp={context.rsvp}
                                onGoLogin={() =>
                                    openLoginDialog({
                                        ...context,
                                        mode: 'login',
                                        eventId: contextEventId,
                                        token: contextToken,
                                    })
                                }
                            />
                        ) : dialogMode === 'forgot' ? (
                            <ForgotPassword
                                bookingDialog
                                onGoLogin={() =>
                                    openLoginDialog({
                                        ...context,
                                        mode: 'login',
                                        eventId: contextEventId,
                                        token: contextToken,
                                    })
                                }
                            />
                        ) : (
                            <Login
                                bookingDialog
                                onCloseDialog={closeLoginDialog}
                                onGoRegister={() =>
                                    openLoginDialog({
                                        ...context,
                                        mode: 'register',
                                        eventId: contextEventId,
                                        token: contextToken,
                                    })
                                }
                                onGoForgot={() =>
                                    openLoginDialog({
                                        ...context,
                                        mode: 'forgot',
                                        eventId: contextEventId,
                                        token: contextToken,
                                    })
                                }
                            />
                        )}
                    </Suspense>
                </DialogContent>
            </Dialog>
        </>
    );
};

Navbar.propTypes = {
    logout: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    app: PropTypes.object.isRequired,
    artist: PropTypes.object,
    host: PropTypes.object,
    events: PropTypes.object,
    getCurrentAttendee: PropTypes.func.isRequired,
    resendVerificationEmail: PropTypes.func,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    app: state.app,
    artist: state.artist,
    host: state.host,
    events: state.event,
});
export default connect(mapStateToProps, {
    logout,
    openNavDrawer,
    closeNavDrawer,
    changeHats,
    openLoginDialog,
    closeLoginDialog,
    // openUserDrawer,
    // closeUserDrawer,
    getCurrentArtist,
    setCurrentArtist,
    getCurrentHost,
    getCurrentAttendee,
    getMyEventsOfferedToHost,
    getEventsNearMeToHost,
    getMyArtistEventsOffers,
    getDiffArtistEventsOffers,
    resendVerificationEmail,
})(Navbar);
